import {faMessageQuestion} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';
import {useCallback, useEffect, useState} from 'react';

import {useDomainConfig} from '../../provider/domain-config/domain-config-hook';
import {initHubspot} from '../../provider/domain-config/init-scripts/init-scripts';
import {classNames} from '../../util/css';

import * as styles from './hubspot-chat-widget.scss';

export function HubspotChatWidget(): JSX.Element | null {
    const [active, setActive] = useState(false);
    const {isHubspotChatShow} = useDomainConfig();

    useEffect(() => {
        if (isHubspotChatShow) {
            initHubspot();
        }
    }, [isHubspotChatShow]);

    useEffect(() => {
        const htmlElement = document.querySelector('html');

        function updateState() {
            setActive(Boolean(htmlElement?.className.includes('hs-messages-widget-open')));
        }

        const observer = new MutationObserver(updateState);

        if (htmlElement) {
            observer.observe(htmlElement, {childList: false, subtree: false, attributeFilter: ['class']});
        }

        updateState();

        return () => observer.disconnect();
    }, []);

    const handleClick = useCallback(() => {
        window.HubSpotConversations?.widget.open();
    }, []);

    return (
        <Button
            className={classNames(styles.HubspotChatWidget, {
                [styles.HubspotChatWidget__hidden]: active || !isHubspotChatShow,
            })}
            icon={<FontAwesomeIcon icon={faMessageQuestion} />}
            onClick={handleClick}
            type="primary"
        />
    );
}
